/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/browser_medium'
export default icon
